import React, { useEffect } from 'react';
import './flower.scss';

function Flower() {
  useEffect(() => {
    const c = setTimeout(() => {
      document.body.classList.remove('not-loaded');
      clearTimeout(c);
    }, 1000);
  }, []);

  return (
    <>
      <div className="night" aria-hidden="true"></div>
      <div className="flowers">
        <div className="flower flower--1">
          <div className="flower__leafs flower__leafs--1">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`flower__leaf flower__leaf--${i}`}></div>
            ))}
            <div className="flower__white-circle"></div>
            {[...Array(8)].map((_, i) => (
              <div key={i} className={`flower__light flower__light--${i + 1}`}></div>
            ))}
          </div>
          <div className="flower__line">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className={`flower__line__leaf flower__line__leaf--${i}`}></div>
            ))}
          </div>
        </div>

        <div className="flower flower--2">
          <div className="flower__leafs flower__leafs--2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`flower__leaf flower__leaf--${i}`}></div>
            ))}
            <div className="flower__white-circle"></div>
            {[...Array(8)].map((_, i) => (
              <div key={i} className={`flower__light flower__light--${i + 1}`}></div>
            ))}
          </div>
          <div className="flower__line">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`flower__line__leaf flower__line__leaf--${i}`}></div>
            ))}
          </div>
        </div>

        <div className="flower flower--3">
          <div className="flower__leafs flower__leafs--3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`flower__leaf flower__leaf--${i}`}></div>
            ))}
            <div className="flower__white-circle"></div>
            {[...Array(8)].map((_, i) => (
              <div key={i} className={`flower__light flower__light--${i + 1}`}></div>
            ))}
          </div>
          <div className="flower__line">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`flower__line__leaf flower__line__leaf--${i}`}></div>
            ))}
          </div>
        </div>

        <div className="grow-ans" style={{ '--d': '1.2s' }}>
          <div className="flower__g-long">
            <div className="flower__g-long__top"></div>
            <div className="flower__g-long__bottom"></div>
          </div>
        </div>

        <div className="growing-grass">
          {[1, 2].map((n) => (
            <div key={n} className={`flower__grass flower__grass--${n}`}>
              <div className="flower__grass--top"></div>
              <div className="flower__grass--bottom"></div>
              {[...Array(8)].map((_, i) => (
                <div
                  key={i}
                  className={`flower__grass__leaf flower__grass__leaf--${i + 1}`}
                ></div>
              ))}
              <div className="flower__grass__overlay"></div>
            </div>
          ))}
        </div>

        {[2.4, 2.8, 3.2].map((delay, i) => (
          <div key={i} className="grow-ans" style={{ '--d': `${delay}s` }}>
            <div className={`flower__g-right flower__g-right--${i + 1}`}>
              <div className="leaf"></div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Flower;
